export { default as FormsProfesorListar } from './Listar';
export { default as CalificarFormulario } from './Calificar';
export { default as DetalleFormulario } from './Detalle';
